module.exports = __webpack_public_path__ + "img/04.5a163d3f.png";